import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import LayoutRoutes from './LayoutRoutes'
import PrivateRoutes from './PrivateRoutes';
import SignIn from '../Auth';
import ResetPasswordPage from '../Auth/ResetPasswordPage';

export default function Routers() {
    const login = localStorage.getItem("login");
    const publicUrl = process.env.PUBLIC_URL;
    const basename = publicUrl && publicUrl !== '.' ? publicUrl : '/';

    return (
        <BrowserRouter basename={basename}>
            <Routes>
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                {login ? (
                    <>
                        <Route path={"/"} element={<Navigate to={'/dashboard/default'} />} />
                    </>
                ) : null}
                <Route path={"/"} element={<PrivateRoutes />}>
                    <Route path={"/*"} element={<LayoutRoutes />} />
                </Route>
                <Route path={'/login'} element={<SignIn />} />
            </Routes>
        </BrowserRouter>
    )
}